import { PropsWithChildren } from 'react';

import {
  ICurrencyAccount,
  useVabsAccountsStore,
} from '@/entities/currency-account';
import {
  useAccountStore,
  useTotalBalanceStore,
} from '@/entities/currency-account/model/store';

import {
  Button,
  DashboardDialog,
  DashboardDialogProps,
  Heading,
  SmallCloseButton,
  Typography,
} from '@/shared/ui';

import { AssetsItem } from './assets-item';

interface TotalAssetsModalContentProps
  extends Pick<TotalAssetsModalProps, 'onAddAccount'> {
  accounts: ICurrencyAccount[];
}

const TotalAssetsHeader: React.FC<{ balance: string }> = ({ balance }) => {
  return (
    <div className="flex justify-between p-5 pb-5">
      <div className="flex flex-col gap-y-2">
        <Typography variant="14-m" color="text-base-100">
          Total assets
        </Typography>
        <Heading variant="s" tag="span" className="text-left">
          {balance}
        </Heading>
      </div>
      <SmallCloseButton />
    </div>
  );
};
const TotalAssetsModalContent = ({
  accounts,
  onAddAccount,
}: TotalAssetsModalContentProps) => {
  return (
    <>
      <div className="flex max-h-[498px] flex-col items-center rounded-[32px] pb-[68px]">
        {accounts.map((account) => (
          <AssetsItem
            account={account}
            key={account.id}
            className="w-full last:mb-6"
          />
        ))}
      </div>
      <div className="fixed bottom-0 left-0 right-0 w-full rounded-[32px] bg-base-500 p-1">
        <Button
          variant="contrast-500"
          size="d-l"
          className="!w-full"
          onClick={onAddAccount}
        >
          + Add account
        </Button>
      </div>
    </>
  );
};
interface TotalAssetsModalProps
  extends PropsWithChildren<Partial<DashboardDialogProps>> {
  onAddAccount?: VoidFunction;
}
export const TotalAssetsModal = ({
  children,
  onAddAccount,
  ...props
}: TotalAssetsModalProps) => {
  const accounts = useVabsAccountsStore((state) => state.accounts);
  const account = useAccountStore((state) => state.account);
  const totalBalance = useTotalBalanceStore((state) => state.totalBalance);
  return (
    <DashboardDialog
      contentClassName="max-h-[600px] p-0"
      header={
        <TotalAssetsHeader
          balance={`${totalBalance?.amount || '0'} ${totalBalance?.symbol || account?.symbol || ''}`}
        />
      }
      content={
        <TotalAssetsModalContent
          accounts={accounts.filter((i) => i.status === 'ACTIVE')}
          onAddAccount={onAddAccount}
        />
      }
      size="md"
      hideCloseButton
      animationProps={{ isFirst: true }}
      {...props}
    >
      {children}
    </DashboardDialog>
  );
};
